import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import FooterFacebookIcon from '../SVG/Footer/FooterFacebookIcon';
import FooterInstagramIcon from '../SVG/Footer/FooterInstagramIcon';
import FooterDiscordIcon from '../SVG/Footer/FooterDiscordIcon';
import FooterPinterestIcon from '../SVG/Footer/FooterPinterestIcon';
import FooterTwitterIcon from '../SVG/Footer/FooterTwitterIcon';
import FooterYoutubeIcon from '../SVG/Footer/FooterYoutubeIcon';
import FooterTiktokIcon from '../SVG/Footer/FooterTiktokIcon';
import FooterSnapchatIcon from '../SVG/Footer/FooterSnapchat';
import GlobalContext from '../../contexts/GlobalContext';

const FooterSocialIcons = (): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const footerConfig = window.caastle.linklists;
  const facebookUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.facebook_url;
  const instagramUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.instagram_url;
  const pinterestUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.pinterest_url;
  const youtubeUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.youtube_url;
  const twitterUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.twitter_url;
  const tiktokUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.tiktok_url;
  const snapchatUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.snapchat_url;
  const discordUrl = globalContext.shopMetaFieldsBootstrapReleaseContent?.discord_url;
  const iconComponentMap = {
    facebook: { component: FooterFacebookIcon, url: facebookUrl },
    instagram: { component: FooterInstagramIcon, url: instagramUrl },
    pinterest: { component: FooterPinterestIcon, url: pinterestUrl },
    youtube: { component: FooterYoutubeIcon, url: youtubeUrl },
    twitter: { component: FooterTwitterIcon, url: twitterUrl },
    tiktok: { component: FooterTiktokIcon, url: tiktokUrl },
    snapchat: { component: FooterSnapchatIcon, url: snapchatUrl },
    discord: { component: FooterDiscordIcon, url: discordUrl }
  };

  return (
    <div className="footer-bottom footer-social">
      <ul className="footer-bottom__inner sj-footer-row js-social-row no-bullet">
        {footerConfig['footer-social-icons'].links.map((link, index) => {
          const handle = link.handle.toLowerCase();
          const iconData = iconComponentMap[handle];

          const isEnabled = iconData && iconData.url && iconData.url !== 'FALSE';

          if (isEnabled) {
            const updatedUrl = iconData.url ? iconData.url : link.url;
            const IconComponent = iconData.component;
            return (
              <li key={index} className="footer-social__list-item">
                <Link
                  to={{ pathname: updatedUrl }}
                  target="_blank"
                  className="footer-social__link">
                  <IconComponent />
                </Link>
              </li>
            );
          }

          return null;
        })}
      </ul>
    </div>
  );
};

export default FooterSocialIcons;
